import script from "./UserAmbassadorListing.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAmbassadorListing.vue?vue&type=script&setup=true&lang=js"

import "./UserAmbassadorListing.vue?vue&type=style&index=0&id=79cae102&lang=css"

const __exports__ = script;

export default __exports__